import { Injectable } from "@angular/core";

import { datesToDb, dbToDates, EntitetStatus, intsToDb } from "@dffedb/util";
import { Note, NoteDbMapperService } from "@e-forsyning/common/note";

import { KomponentGruppe } from "./model/komponent-gruppe.model";
import { Komponent } from "./model/komponent.model";

@Injectable({ providedIn: "root" })
export class KomponentMapper {
    constructor(private readonly noteMapper: NoteDbMapperService) {}

    public dtoToKomponentGruppe(data: any, bilagUrlTemplate: string): KomponentGruppe {
        const result: any = {
            ...data,
            komponenter: data.komponenter.map((komponent: any) => ({
                ...komponent,
                nedtagetDato: dbToDates(komponent.nedtagetDato),
                noter: komponent.noter.map((note: any): Note => this.noteMapper.dbToNote(note, bilagUrlTemplate)),
                opsatDato: dbToDates(komponent.opsatDato),
                senestServiceDato: dbToDates(komponent.senestServiceDato),
                serieNr: komponent.serieNr,
                serviceDato: dbToDates(komponent.serviceDato),
                status: this.beregnStatus(komponent.status)
            }))
        };
        return result as KomponentGruppe;
    }

    public komponentGruppeToDto(data: KomponentGruppe): any {
        const result = {
            ...data,
            komponenter: data.komponenter.map((komponent: Komponent) => ({
                ...komponent,
                nedtagetDato: datesToDb(komponent.nedtagetDato),
                senestServiceDato: datesToDb(komponent.senestServiceDato),
                serviceDato: datesToDb(komponent.serviceDato),
                opsatDato: datesToDb(komponent.opsatDato),
                serviceAar: intsToDb({
                    oprindelig: 0,
                    aktuel: 0
                }), // Dummy for at få AppServeren til ikke at fejle med 500. 'serviceAar' bliver ikke længere brugt til noget.
                noter: komponent.noter.map((note: Note) => this.noteMapper.noteToDb(note))
            }))
        };
        return result;
    }

    private beregnStatus(status: EntitetStatus): EntitetStatus {
        if (status === null || status === undefined) {
            return EntitetStatus.Uaendret;
        }
        return status;
    }
}
